export const PERIOD = {
    BOY: 'BOY',
    MOY: 'MOY',
    EOY: 'EOY',
    SUMMER: 'SUMMER',
    PM: 'PM',
};

export const GRADE = {
    PK: 'PK',
    KG: 'KG',
    ONE: '01',
    TWO: '02',
    THREE: '03',
    FOUR: '04',
    FIVE: '05',
    SIX: '06',
    SEVEN: '07',
};

export const PERIOD_LABEL = {
    [PERIOD.BOY]: 'Beginning of Year',
    [PERIOD.MOY]: 'Middle of Year',
    [PERIOD.EOY]: 'End of Year',
    [PERIOD.SUMMER]: 'SUMMER',
    [PERIOD.PM]: 'Progress Monitoring',
};

const constructLabelObject = ({ prefix, kgLabel }) => ({
    ...Object.keys(GRADE).reduce(
        (gradeLabels, gradeKey) => ({
            ...gradeLabels,
            [GRADE[gradeKey]]: `${prefix}${parseInt(GRADE[gradeKey], 10)}`,
        }),
        {},
    ),
    [GRADE.PK]: 'PreK',
    [GRADE.KG]: kgLabel,
});

export const GRADE_LABEL = constructLabelObject({ prefix: 'Grade ', kgLabel: 'Kindergarten' });

export const GRADE_LABEL_SHORT = constructLabelObject({ prefix: 'G', kgLabel: 'GK' });

export const BM_PERIODS = [PERIOD.BOY, PERIOD.MOY, PERIOD.EOY];
export const ALL_PERIODS = [...BM_PERIODS, PERIOD.PM];

export const MCLASS_PORTAL_OWA_ACTIVE_TAB = 'mclass_portal_owa_active_tab';

export const LECTURA_SERVICE_MODE = 'lectura';

export const PM_GRADE_AVAILABILITY = [
    GRADE.KG,
    GRADE.ONE,
    GRADE.TWO,
    GRADE.THREE,
    GRADE.FOUR,
    GRADE.FIVE,
    GRADE.SIX,
];
